<div class="login-page">
  <div class="login-card">

    <div class="brand">
      <img class="brand-mark" src="favicon.svg" alt="" width="52" height="52">
      <div class="brand-text">
        <h1>Optimus</h1>
        <p class="tagline">AI-augmented test automation</p>
      </div>
    </div>

    <p class="blurb">
      Turn requirements into running, verified regression tests — generated against your own
      application and re-checked every time it changes.
    </p>

    <div class="banner err" *ngIf="error">
      <mat-icon>error_outline</mat-icon>
      <span>{{ error }}</span>
    </div>

    <div class="checking" *ngIf="checking">
      <mat-spinner diameter="20"></mat-spinner>
      <span>Checking your session…</span>
    </div>

    <ng-container *ngIf="!checking">
      <button mat-flat-button color="primary" class="signin" (click)="signIn()">
        Sign in
      </button>
      <p class="hint">
        You'll be taken to your organisation's secure sign-in page, then brought back here.
      </p>
    </ng-container>

    <p class="footer">TechWish&nbsp;&middot;&nbsp;Access is granted by your administrator</p>
  </div>
</div>
